import AdminHotelEditBarService from './admin-hotel-edit-bar-service';
import AdminHotelEditBar from './admin-hotel-edit-bar-component';

import './admin-hotel-edit-bar.scss';

const MODULE_NAME = 'app.admin.hotel-edit.bar';
const module = angular
    .module(MODULE_NAME, [])
    .directive(AdminHotelEditBar.DIRECTIVE_NAME, AdminHotelEditBar)
    .service('adminHotelEditBarService', AdminHotelEditBarService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-bar/admin-hotel-edit-bar-module.js